export default "__VITE_ASSET__7489ec99__"